var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstructOneBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 425,
    height: 294,
    viewBox: "0 0 425 294",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.18617 13.8686C-0.961827 6.58593 4.66724 0 12.0398 0H391.571C397.477 0 402.505 4.29746 403.425 10.1315L424.705 145.131C424.901 146.37 424.901 147.63 424.705 148.869L403.425 283.869C402.505 289.703 397.477 294 391.571 294H12.0398C4.66721 294 -0.961829 287.414 0.186167 280.131L20.8778 148.869C21.0729 147.63 21.0729 146.37 20.8778 145.131L0.18617 13.8686Z",
    fill: "#314064"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstructOneBg);
export default __webpack_public_path__ + "static/media/instructOneBg.1f6b6242e72dd90efc79cff9b2d0773e.svg";
export { ForwardRef as ReactComponent };